<div class="background" (click)="closeFilter()" id="overlay"></div>
<div
  role="dialog"
  class="menu-content"
  [ngStyle]="objPosition"
  id="filter"
  #tableFilterServer
  aria-labelledby="dialog-title"
  aria-describedby="dialog-description"
>
  <div *ngIf="columnId.filterOn != 8; else elseBlock">
    <div class="filter-search-content nr-form-fields-wrapper">
      <div class="nr-form-group">
        <input
          type="text"
          autocomplete="off"
          [formControl]="queryField"
          class="nr-form-control nr-search-control"
          placeholder="Search"
          id="email"
        />
      </div>
      <div class="option-list-filter">
        <div class="list-item">
          <mat-checkbox
            #selectAll
            [checked]="isSelectedAll"
            class="nr-checkbox nr-checkbox-sm"
            (change)="selectDeselectAll($event)"
            [color]="'primary'"
          >
            Select All
          </mat-checkbox>
        </div>
        <cdk-virtual-scroll-viewport [itemSize]="20" class="scroll-container">
          <div
            class="list-item"
            *cdkVirtualFor="let option of optionList; let i = index"
          >
            <mat-checkbox
              [value]="option.name"
              [checked]="option.isSelected"
              [color]="'primary'"
              class="nr-checkbox nr-checkbox-sm"
              (change)="setValue($event, i)"
            >
              <ng-container>
                {{ option.name }}
              </ng-container>
            </mat-checkbox>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>

      <div class="nr-button-section pt-4">
        <button class=" nr-button-sm" (click)="closeFilter()">
          Cancel
        </button>
        <button
          class=" nr-button-primary nr-button-sm"
          (click)="searchApply()"
        >
          Filter
        </button>
      </div>
    </div>
  </div>
  <ng-template #elseBlock>
    <div id="leftbox">
      <mat-radio-group
        class="example-radio-group"
        (change)="changeComboo($event)"
        [(ngModel)]="selectedDateType"
      >
        <mat-radio-button
          class="example-radio-button"
          *ngFor="let opt of calType"
          [value]="opt"
        >
          {{ opt }}
        </mat-radio-button>
      </mat-radio-group>
      <!-- {{ selectedDateType }} -->
      <div class="nr-button-section">
        <button class=" nr-button-sm" (click)="closeFilter()">
          Cancel
        </button>
        <button
          class=" nr-button-primary nr-button-sm"
          (click)="searchApply()"
        >
          Filter
        </button>
      </div>
    </div>
    <div id="rightbox" *ngIf="selectedDateType == 'Custom date'">
      <sat-card>
        <sat-calendar
          [maxDate]="maxDate"
          [selected]="selectedDate"
          (selectedChange)="onSelect($event)"
        ></sat-calendar>
      </sat-card>
    </div>

    <div id="date-range-rightbox" *ngIf="selectedDateType == 'Custom range'">
      <sat-calendar
        [rangeMode]="true"
        (dateRangesChange)="inlineRangeChange($event)"
        [maxDate]="maxDate"
      >
      </sat-calendar>
    </div>
  </ng-template>
</div>
